import _classCallCheck from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React, { Component, PropTypes } from 'react';
import styles from '../../../build/styles';
import { getCallbacks } from '../../helper/helper';

var PanelBlock =
/*#__PURE__*/
function (_Component) {
  _inherits(PanelBlock, _Component);

  function PanelBlock() {
    _classCallCheck(this, PanelBlock);

    return _possibleConstructorReturn(this, _getPrototypeOf(PanelBlock).apply(this, arguments));
  }

  _createClass(PanelBlock, [{
    key: "createClassName",
    value: function createClassName() {
      return [styles.panelBlock, this.props.isActive ? styles.isActive : '', this.props.className].join(' ').trim();
    }
  }, {
    key: "renderIcon",
    value: function renderIcon() {
      return React.createElement('span', {
        className: styles.panelIcon
      }, React.createElement('i', {
        className: [styles.fa, this.props.icon].join(' ')
      }));
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement('span', _extends({}, getCallbacks(this.props), {
        style: this.props.style,
        className: this.createClassName()
      }), this.props.icon ? this.renderIcon() : null, this.props.children);
    }
  }]);

  return PanelBlock;
}(Component);

export { PanelBlock as default };
PanelBlock.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  isActive: PropTypes.bool,
  icon: PropTypes.string,
  style: PropTypes.object
};
PanelBlock.defaultProps = {
  className: '',
  style: {}
};